export const emptyBoard = (height, width) => {
  return Array(height).fill().map(() => Array(width).fill().map(() => null));
};

export const emptyTray = () => {
  return Array(14).fill().map(() => null);
}
